import { NAME_SPACES } from "shared/locales/constants";
import acoris from "./acoris";
import contact from "./contact";
import processes from "./processes";

const translations = {
  [NAME_SPACES.PUBLIC.CONTACT]: contact,
  [NAME_SPACES.PUBLIC.PROCESSES]: processes,
  [NAME_SPACES.PUBLIC.ACORIS]: acoris,
};

export default translations;
